import React, { useEffect, useState } from "react";
import { FaBuilding, FaListAlt } from "react-icons/fa";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../BaseURL";

export default function Dashboarddata() {
  const [totalProjects, setTotalProjects] = useState(0);
  const [totalCategories, setTotalCategories] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        // Fetch projects count
        const projectsRes = await axios.get(`${BASE_URL}/api/projects`);
        const projects = projectsRes.data.data || [];
        setTotalProjects(projects.length);

        // Fetch categories count
        const categoriesRes = await axios.get(
          `${BASE_URL}/api/category/get-category`,
        );
        const categories = categoriesRes.data.data || categoriesRes.data || [];
        setTotalCategories(categories.length);
      } catch (error) {
        console.error("Dashboard count error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, []);

  return (
    <div className="dashboard-summary-container">
      <h2 className="dashboard-title">Dashboard Summary</h2>

      <div className="dashboard-cards-grid">
        {/* TOTAL PROJECTS */}
        <div className="dashboard-card">
          <div className="dashboard-card-inner">
            <div className="dashboard-icon projects-icon">
              <FaBuilding size={40} />
            </div>
            <div className="dashboard-content">
              <h6 className="dashboard-label">Total Projects</h6>
              <h3 className="dashboard-value">
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  totalProjects
                )}
              </h3>
            </div>
          </div>
        </div>

        {/* TOTAL CATEGORIES */}
        <div className="dashboard-card">
          <div className="dashboard-card-inner">
            <div className="dashboard-icon categories-icon">
              <FaListAlt size={40} />
            </div>
            <div className="dashboard-content">
              <h6 className="dashboard-label">Total Categories</h6>
              <h3 className="dashboard-value">
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  totalCategories
                )}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
